import dropdownEnums, { Enums } from "@/services/dropdown-enums";
import { emailRegx } from "@/services/schemas/genericSchemas";
import moment from "moment";

export const tabEnum = {
  1: "lead-form",
  // 2: "deals",
  // 3: "product-services",
};
export const InitialInfo = { data: [], loading: false };

export const createData = () => {
  let data = {};
  for (const key in tabEnum) {
    data[tabEnum[key]] = InitialInfo;
  }
  return data;
};

export const removeEmptyKeys = (data) => {
  let copiedData = JSON.parse(JSON.stringify(data));
  if (copiedData && Object.keys(copiedData).length) {
    for (let key in copiedData) {
      if (
        (!copiedData[key] && typeof copiedData[key] !== "boolean") ||
        (Array.isArray(copiedData[key]) &&
          (!copiedData[key].length ||
            !copiedData[key].every((item) => item.value)))
      ) {
        delete copiedData[key];
      }
    }
  }
  return copiedData;
};

export const getFieldsCountByType = (allFields = []) => {
  return allFields.reduce((prev, curr) => {
    if (prev[curr.fieldType]) {
      prev[curr.fieldType] = prev[curr.fieldType] + 1;
    } else {
      prev[curr.fieldType] = 1;
    }
    return prev;
  }, {});
};

export const getFieldsLimitInfoByType = (allFields = []) => {
  let fieldsInfo = {};
  allFields.map((field) => {
    fieldsInfo[field?.fieldType] = { ...field };
  });
  return fieldsInfo;
};

export const getCustomFieldEnumKey = (type, key) => {
  return dropdownEnums.enum_Custom_Field_Type.find((e) => e[key] === type)?.[
    "key"
  ];
};
export const getCustomSubFieldEnumKey = (type, key) => {
  return dropdownEnums.enum_Custom_Field_Sub_Type.find(
    (e) => e[key] === type
  )?.["key"];
};

export const arrayToCommaSeparatedString = (arr) => {
  if (arr.length === 0) {
    return ""; // Return an empty string for an empty array
  } else if (arr.length === 1) {
    return arr[0]; // Return the single element for an array with one element
  } else {
    const lastElement = arr.pop(); // Remove the last element from the array
    const commaSeparatedString = arr.join(", "); // Join the remaining elements with commas
    return `${commaSeparatedString} and ${lastElement}`; // Add 'and' before the last element
  }
};

export const getFieldValidationByType = (fieldValues) => {
  switch (fieldValues.fieldType) {
    case Enums.CustomFieldType.Text:
      return stringify(TextValidation(fieldValues.fieldSubType));
    case Enums.CustomFieldType.Numeric:
      // not stringfy it cause do decimal value in it, manually stringified
      return NumericValidation(fieldValues.fieldSubType);
    case Enums.CustomFieldType.Datetime:
      return stringify(DateTimeValidation(fieldValues.fieldSubType));
    default:
      return null;
  }
};

const stringify = (value = null) => {
  return value ? JSON.stringify(value) : value;
};

const TextValidation = (subType) => {
  switch (subType) {
    case Enums?.CustomFieldSubType.Email:
      return {
        IsRegex: true,
        Regex: `${emailRegx}`,
        IsMask: false,
        Mask: "",
        Prefix: "",
      };
    // will be open if any specific validation required for phone type
    // case Enums?.CustomFieldSubType.Phone:
    //   return {
    //     IsRegex: false,
    //     Regex: "",
    //     IsMask: false,
    //     Mask: "",
    //     Prefix: "",
    //   };
    default:
      return null;
  }
};
const NumericValidation = (subType) => {
  switch (subType) {
    case Enums.CustomFieldSubType.Currency:
      return '{"IsBetween":false,"StartFrom":1.0,"EndTo":16.0}';
    case Enums.CustomFieldSubType.None:
      return '{"IsBetween":false,"StartFrom":0.0,"EndTo":16.0}';
    default:
      return null;
  }
};
const DateTimeValidation = (subType) => {
  switch (subType) {
    case Enums.CustomFieldSubType.Date:
    case Enums.CustomFieldSubType.DateAndTime:
      return {
        Format: "",
        IsBetween: false,
        StartFrom: moment().set("year", 1900).startOf("year").unix(), // start date unix timestamp
        EndTo: moment().set("year", 2100).endOf("year").unix(), // end date unix timestamp
      };
    default:
      return null;
  }
};
